import React from 'react';
import styled from 'styled-components';

import { ButtonBaseProps, Typography } from '@material-ui/core';
import CallEndIcon from '@material-ui/icons/CallEnd';

import IconBorder from 'components/shared/IconBorder';
import HorizontalContent from 'components/shared/HorizontalContent';
import { StyledIconButton } from 'components/shared/MuiExtensions';

import { useTheme } from '@material-ui/core/styles';

interface AnswerCallProps extends ButtonBaseProps {
  label: string;
}

const Wrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const AnswerCall = ({ label, ...props }: AnswerCallProps) => {
  const theme = useTheme();
  return (
    <Wrapper>
      <HorizontalContent>
        <Typography variant="subtitle1">{label}</Typography>
        <StyledIconButton {...props}>
          <IconBorder boxShadow>
            <CallEndIcon htmlColor={theme.palette.background.green} />
          </IconBorder>
        </StyledIconButton>
      </HorizontalContent>
    </Wrapper>
  );
};

export default AnswerCall;
